import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {INotificationResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {i18n} from '@toolify/client/src/setup/i18n'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

const {t} = i18n.global

export class DatabaseItemFileCreatedNotificationStrategy extends DefaultNotificationStrategy<NotificationType.DatabaseItemFileCreated> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.DatabaseItemFileCreated>, authorNick: string): IBrowserNotification {
    return {
      sound: getNotificationSoundUrl('new-notification.wav'),
      title: ENV.AppBrandingName,
      body: t('notifications.browserNotifications.databaseItemFileCreated', {author: authorNick}),
    }
  }
}
